import { Component } from '@angular/core';

import { Observable } from 'rxjs';

import { FileUtils, RendererBaseComponent, FileResponse } from 'sc-common';
import { ApiPaperSupplementListItem } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    templateUrl: './supplement-materials-renderer.component.html',
    standalone: false
})

export class SupplementMaterialsRendererComponent extends RendererBaseComponent {

    public downloadFileExpr: (rowModel: ApiPaperSupplementListItem) => Observable<FileResponse>;

    constructor() {
        super();
    }

    public getFileIconClass(fileName: string): string {
        return FileUtils.getFileIconClass(fileName);
    }
}
